<div class="flex flex-col -m-6">

    <!-- Header -->
    <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'services.workplaces.syncUsers' | transloco }}</div>
        
        <button mat-icon-button [tabIndex]="-1" (click)="closeDialog()">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-row items-center justify-center p-2 pt-8 sm:items-start w-full">
        <mat-form-field class="w-full lg:w-1/2">
            <mat-label>{{ 'services.workplaces.syncMails' | transloco }}</mat-label>
            <mat-chip-grid #chipGrid [formControl]="mailsControl">
                @for (mail of mails(); track mail) {
                <mat-chip-row (removed)="remove(mail)">
                    {{ mail }}
                    <button matChipRemove>
                        <mat-icon>cancel</mat-icon>
                    </button>
                </mat-chip-row>
                }
                <input [matChipInputFor]="chipGrid" (matChipInputTokenEnd)="add($event)" [matChipInputSeparatorKeyCodes]="separators" [matChipInputAddOnBlur]="true" />
            </mat-chip-grid>
        </mat-form-field>
    </div>

    <!-- Actions -->
    <div class="flex flex-row justify-end px-4 pb-2 sm:px-8 sm:pb-4 w-full">
        <button mat-raised-button color="primary" (click)="sync()">{{ 'services.workplaces.syncUsers' | transloco }}</button>
    </div>
</div>